<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { onboardingVideoOrder } from '@/data/onboarding'
import type { OnboardingPhase } from '@/stores/onboarding'
import { onboardingLog } from '@/services/onboardingLog'

const props = withDefaults(defineProps<{ phase: OnboardingPhase; plans?: boolean; title?: string }>(), {
  plans: false, title: 'AI Video\nGenerator & Maker',
})
const progress = computed(() => props.phase === 'plans'
  ? onboardingVideoOrder.length
  : onboardingVideoOrder.findIndex(step => step === props.phase) + 1)
onMounted(() => onboardingLog('debug', '[FIX:UNI-116] responsive_layout', {
  layout: window.innerWidth >= 900 ? 'desktop' : 'mobile', phase: props.phase,
}))
</script>

<template>
  <main class="onboarding-backdrop">
    <header class="onboarding-web-header">
      <div class="onboarding-web-brand">
        <img
          src="/assets/onboarding/logo.svg"
          alt="UIG"
        >
        <span>{{ title.split('\n')[0] }}<small>{{ title.split('\n')[1] }}</small></span>
      </div>
      <div
        v-if="progress"
        class="onboarding-web-progress"
        :aria-label="`${progress} / ${onboardingVideoOrder.length}`"
      >
        <i
          v-for="step in onboardingVideoOrder.length"
          :key="step"
          :class="{ 'is-complete': step <= progress }"
        />
      </div>
    </header>
    <div
      class="onboarding-stage"
      :class="{ 'onboarding-plans-stage': plans }"
      :data-phase="phase"
    >
      <slot />
    </div>
  </main>
</template>
